/* eslint-disable */

<template>
    <div ref="home">
        <div class="d-flex justify-end full-width">
            <v-btn color="primary" @click.stop="search_qr = true"><v-icon class="mr-2">qr_code</v-icon>cerca QR</v-btn>
        </div>
        <div v-can="{obj_type:'home', action: 'statistic'}">
        <div class="text-h6 text-uppercase  mt-4 ml-2">
            statistiche generali
        </div>
        <v-row>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div class="black fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4">
                            <div class="text-truncate font-weight-bold text-uppercase">clienti</div>
                            <div>
                                <v-progress-circular
                                v-if="s_count"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{stats.c_count}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="warning" class="black fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4">
                            <div class="text-truncate font-weight-bold text-uppercase">sedi</div>
                            <div>
                                <v-progress-circular
                                v-if="s_count"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{stats.l_count}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div class="black fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 ">
                            <div class="text-truncate font-weight-bold text-uppercase">strumenti</div>
                            <div><v-progress-circular
                                v-if="s_count"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{stats.i_count}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <!--div class="text-h6 text-uppercase font-italic mt-4 ml-2">
            Tarature scientifiche (ISO)
        </div>
        <v-row>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div class="error fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 error--text cursor_pointer" @click.stop="goTo('instruments', 'iso', 'alert')">
                            <div class="text-truncate font-weight-bold text-uppercase">scaduti</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{iso['alert'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="warning" class="warning fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 warning--text cursor_pointer" @click.stop="goTo('instruments', 'iso', 'warning')">
                            <div class="text-truncate font-weight-bold text-uppercase">in scadenza</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{iso['warning'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="success" class="success fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 success--text cursor_pointer" @click.stop="goTo('instruments', 'iso', 'ready')">
                            <div class="text-truncate font-weight-bold text-uppercase">in validità</div>
                            <div ><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span class="text-h4 font-weight-bold" v-else>{{iso['ready'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            
        </v-row-->
        
        <div class="text-h6 text-uppercase font-italic mt-4 ml-2">
            Verificazioni Periodiche
        </div>
        <v-row>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div class="error fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 error--text cursor_pointer" @click.stop="goTo('instruments', 'leg', 'alert')">
                            <div class="text-truncate font-weight-bold text-uppercase">scaduti</div>
                            <div>
                                <v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{leg['alert'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="warning" class="warning fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 warning--text cursor_pointer" @click.stop="goTo('instruments', 'leg', 'warning')">
                            <div class="text-truncate font-weight-bold text-uppercase">in scadenza</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{leg['warning'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="success" class="success fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 success--text cursor_pointer" @click.stop="goTo('instruments', 'leg', 'ready')">
                            <div class="text-truncate font-weight-bold text-uppercase">in validità</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{leg['ready'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            
        </v-row>
        
        <!--div class="text-h6 text-uppercase font-italic mt-4 ml-2">
            Tarature scientifiche semplificate
        </div>
        <v-row>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div class="error fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 error--text cursor_pointer" @click.stop="goTo('instruments', 'iso_simple', 'alert')">
                            <div class="text-truncate font-weight-bold text-uppercase">scaduti</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{iso_simple['alert'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="warning" class="warning fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 warning--text cursor_pointer" @click.stop="goTo('instruments', 'iso_simple', 'warning')">
                            <div class="text-truncate font-weight-bold text-uppercase">in scadenza</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{iso_simple['warning'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
            <v-col lg="4" cols="sm" class="pb-2">
                <v-card>
                    <v-row class="no-gutters">
                        <div class="col-auto">
                            <div color="primary" class="success fill-height">&nbsp;</div>
                        </div>
                        <div class="col pa-3 py-4 success--text cursor_pointer" @click.stop="goTo('instruments', 'iso_simple', 'ready')">
                            <div class="text-truncate font-weight-bold text-uppercase">in validità</div>
                            <div><v-progress-circular
                                v-if="s_loading"
                                indeterminate
                                size="32"
                                width="4"
                                color="primary"
                                ></v-progress-circular><span v-else class="text-h4 font-weight-bold">{{iso_simple['ready'].length}}</span></div>
                        </div>
                    </v-row>
                </v-card>
            </v-col>
        </v-row-->
        </div>
        <BasicCard v-can="{obj_type:'home', action: 'operation'}" class="py-2">
            <template v-slot:title>
                <span class="font-italic">Ultimi interventi nel periodo selezionato: {{ tot_operations }}</span>
            </template>
            <template v-slot:action>
                <v-btn class="ml-2 align-center suggestion white--text" text @click.stop="goTo('operations')">vedi tutti</v-btn>
            </template>
            <div class="d-flex flex-column">
                <div class="d-flex justify-left flex-wrap full-width my-2 pl-2">
                    <v-btn class="my-2" @click="periodChange('operation',0, 0)">oggi</v-btn>
                    <v-btn class="ml-2 my-2" @click="periodChange('operation',1, 1)">ieri</v-btn>    
                    <v-btn class="ml-2 my-2" @click="periodChange('operation', 6, 0)">ultimi 7 giorni</v-btn>
                    <v-btn class="ml-2 my-2" @click="periodChange('operation', 29, 0)">ultimi 30 giorni</v-btn>
                </div>
                <div class="d-flex pa-2">
                    <span><CalendarField
                        v-model="filter.operations.from"
                        clearable
                        label="da">
                    </CalendarField></span>
                    <span class="pl-2"><CalendarField
                        v-model="filter.operations.to"
                        :minDate="filter.operations.from"
                        clearable
                        label="a">
                    </CalendarField></span>
                    <v-btn fab small @click.stop="searchOperations(filter.operations.from, filter.operations.to)" class="ml-2"><v-icon>search</v-icon></v-btn>
                </div>
            </div>
            <v-data-table
                :items="operations"
                :hide-default-footer="true"
                :hide-default-header="true"
                :disable-pagination="true"
                dense>
                <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="operations.length == 0" class="px-2 text-h6 text-center">
                            Nessun intervento trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="op in items" :key="op._id">
                            <td>
                                <OperationItem 
                                    :operation_id="op._id"
                                    :show_action="false"
                                />
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
            <div v-if="tot_operations > 0" class="text-center pa-2">
                <div class="text-right font-italic font-small">Totale: {{ tot_operations }}</div>
            </div>
        </BasicCard>

        <BasicCard v-can="{obj_type:'home', action: 'report'}" class="py-2">
            <template v-slot:title>
                <span class="font-italic">Ultimi report nel periodo selezionato: {{ tot_reports }}</span>
            </template>
            <template v-slot:action>
                <v-btn class="ml-2 suggestion white--text" text @click.stop="goTo('reports')">vedi tutti</v-btn>
            </template>
            <div class="d-flex flex-column">
                <div class="d-flex justify-left flex-wrap full-width my-2 pl-2">
                    <v-btn class="my-2" @click="periodChange('report',0, 0)">oggi</v-btn>
                    <v-btn class="ml-2 my-2" @click="periodChange('report',1, 1)">ieri</v-btn>
                    <v-btn class="ml-2 my-2" @click="periodChange('report', 6, 0)">ultimi 7 giorni</v-btn>
                    <v-btn class="ml-2 my-2" @click="periodChange('report', 29, 0)">ultimi 30 giorni</v-btn>
                </div>
                <div class="d-flex pa-2">
                    <span><CalendarField
                        v-model="filter.reports.from"
                        clearable
                        label="da">
                    </CalendarField></span>
                    <span class="pl-2"><CalendarField
                        v-model="filter.reports.to"
                        :minDate="filter.reports.from"
                        clearable
                        label="a">
                    </CalendarField></span>
                    <v-btn fab small @click.stop="searchReports(filter.reports.from, filter.reports.to)" class="ml-2"><v-icon>search</v-icon></v-btn>
                </div>
            </div>
            <v-data-table
                :items="reports"
                :hide-default-footer="true"
                :hide-default-header="true"
                :disable-pagination="true"
                dense>
                <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="reports.length == 0" class="px-2 text-h6 text-center">
                            Nessun report trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="report in items" :key="report._id">
                            <td>
                                <ReportItem
                                    :key="report._id"
                                    :report_id="report._id"
                                    :show_instrument="true"
                                    :show_client_short="true"
                                    :show_action="false">
                                </ReportItem>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </BasicCard>
        <SearchQR 
            :dialog="search_qr"
            @show_detail="goToInstrument"
            @close="closeQRSearchDialog"/>
        <InstrumentDialog
            ref="newInstrumentEdit"
            v-on:update_instrument="goToInstrument"
        />
    </div>
</template>
<script>
import BasicCard from '../components/utils/Basic_card'
import ReportItem from './reports/ReportItem'
import OperationItem from './operations/OperationItem'
import { subDays, startOfDay, endOfDay } from 'date-fns'
import {filterByOrg, filterByUser, isOrgAdmin} from '../utils/rolesManagement'
import { searchDesign, orderByFields } from "../utils/dbUtility"
import { getExpStatus, getExpStatusDatetime } from "../utils/commonUtils"
import SearchQR from "../components/dialogs/SearchQR"
import InstrumentDialog from "./instruments/InstrumentDialog"

export default {
    name: 'home',
    data() {
        return {
            stats: {
                i_count: 0,
                c_count: 0,
                l_count: 0,

            },
            filter: {
                reports: {
                    from: null,
                    to: null
                },
                operations: {
                    from: null,
                    to: null
                }
            },    
            reports: [],
            tot_reports: 0,
            operations: [],
            tot_operations: 0,
            
            iso: {alert:[], warning:[], ready:[]},
            iso_simple: {alert:[], warning:[], ready:[]},
            leg: {alert:[], warning:[], ready:[]},
            all: {alert:[], warning:[], ready:[]},
            s_loading: true,
            s_count: true,
            search_qr: false
        }
    },
    components: {
        BasicCard, ReportItem, OperationItem, SearchQR, InstrumentDialog
    },
    created() {

    },
    beforeDestroy() {
        this.reports = null
        this.operations = null
        this.iso = null
        this.iso_simple = null
        this.leg = null
        this.all = null
        this.$el = null
    },
    async mounted() {
        await this.getInstrumentsStats(isOrgAdmin(this.$store.state.user.roles))
        let filter = this.$store.state.search[this.$router.history.current.fullPath]
        //console.log("MOUNTED SEARCH PARAMS", this.$router.history.current.fullPath, filter)
        if (!filter) {
            this.filter = {
                reports: {
                    from: 0,
                    to: null
                },
                operations: {
                    from: 0,
                    to: null
                }
            }
            await this.periodChange('operation', 6, 0)
            await this.periodChange('report', 6, 0)
        } else {
            this.filter = Object.assign({}, this.filter, filter)
            await this.searchReports(this.filter.reports.from, this.filter.reports.to)
            await this.searchOperations(this.filter.operations.from, this.filter.operations.to)
        }
    },
    methods: {
        async getInstrumentsStats(filter_by_org) {
            console.log('%%%%%%% START INSTRUMENTS STATS ', Date.now())
            searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', 'client', false)
            this.s_loading = true
            //this.getInstruments(this.iso, filter_by_org, 'exp_iso', 0)
            this.getInstruments(this.leg, 'exp_leg', filter_by_org, 0 )
            //this.getInstruments(this.iso_simple, 'exp_iso_simple', filter_by_org, 0)
            this.s_loading = false
            
            this.s_count = true
            //console.log('%%%%%%%', ['instrument', ...(filter_by_org ? [this.$store.state.user.org_id] : [])])
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'all_keys', ['instrument', ...(isOrgAdmin ? [['org', this.$store.state.user.org_id]] : [])], false)
            this.stats.i_count = res.length
            // this.stats.i_count = (res.length > 0) ? res[0].value : 0
            res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'all_keys', ['client', ...(isOrgAdmin ? [['org', this.$store.state.user.org_id]] : [])], false)
            this.stats.c_count = res.length
            // this.stats.c_count = (res.length > 0) ? res[0].value : 0
            res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'all_keys', ['location', ...(isOrgAdmin ? [['org', this.$store.state.user.org_id]] : [])], false)
            this.stats.l_count = res.length
            // this.stats.l_count = (res.length > 0) ? res[0].value : 0
            this.s_count = false
            console.log('%%%%%%% FINISH INSTRUMENTS STATS', Date.now())
            
        },
        async getInstruments(dest, exp_type, filterByOrg, from, to ){
            console.log('%%%%%%% START INSTRUMENTS SEARCH', Date.now())
            let selectors = []
            if (!from) {
                selectors.push([exp_type])
            } else {
                selectors.push([exp_type, from])
            }
            if (!to) {
                selectors.push([exp_type, {}])
            } else {
                selectors.push([exp_type, to])
            }
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'range', selectors, false)
            // console.log('INSTRUMENT SEARCH', filterByOrg)
            if (res != null) {
                let now = new Date()
                for (let instr of res) {
                    this.getInstrStatus(instr, now, dest, filterByOrg)
                }
            }
            console.log('%%%%%%% FINISH INSTRUMENTS SEARCH', Date.now())
        },
        periodChange(type, f_days, t_days) {
            let now = (new Date()).getTime()
            let from = subDays(now, f_days).getTime()
            let to = subDays(now, t_days).getTime()   
            let sd_from = startOfDay(from).getTime()
            let ed_to = endOfDay(to).getTime()   
            
            switch (type) {
                case 'report':
                    if (sd_from != this.filter.reports.from) {
                        this.filter.reports.from = sd_from
                    }
                    if (ed_to != this.filter.reports.to) {
                        this.filter.reports.to = ed_to
                    }
                    this.searchReports(sd_from, ed_to)

                    break;
                case 'operation':
                    if (sd_from != this.filter.operations.from) {
                        this.filter.operations.from = sd_from
                    }
                    if (ed_to != this.filter.operations.to) {
                        this.filter.operations.to = ed_to
                    }
                    
                    this.searchOperations(sd_from, ed_to)
                    break
            }
            // console.log("CHANGE PERIODO SEARCH PARAMS", this.$router.history.current.fullPath, this.filter)
            
            
        },
        goTo(page, r_type, status){
            let filter_date = null
            let filter = {}
            switch(page) {
                case 'reports':
                    this.$store.commit('setSearchParam', { path: "/reports/list", filter: this.filter.reports })
                    this.$router.push("/reports/list")
                    break;
                case 'operations':
                    this.$store.commit('setSearchParam', { path: "/operations/", filter: this.filter.operations })
                    this.$router.push("/operations/")
                    break;
                case 'instruments':
                    filter_date = getExpStatusDatetime(this.$store.state.config.threshold)
                    filter = _.cloneDeep(filter_date[status])
                    filter.op_type = 'exp_'+r_type
                    this.$store.commit('setSearchParam', { path: "/instruments/", filter: filter})
                    this.$router.push("/instruments/")
                    break
                }
        },
        getInstrStatus(item, now, dest, filterByOrg) {
            if (!filterByOrg || (filterByOrg && item.value.ref_orgs.includes(this.$store.state.user.org_id)) ) {
                let status = getExpStatus(this.$store.state.config.threshold, now, new Date(item.key[1]))
                dest[status].push({_id: item._id, values: item.value})
            }
        },
        async searchReports(from, to){
            console.log('%%%%%%% START REPORT SEARCH', Date.now())
            if (!from) {
                from = 0
            }
            
            if (!to) {
                to = new Date().getTime()
            }
            from = startOfDay(from).getTime()
            to = endOfDay(to).getTime()
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: this.filter })
            let ranges=[['report_date', from], ['report_date', to]]
            let res = await searchDesign(this.$store.state.$pouch, 'reports', 'reports/searchByData', 'range', ranges, false)
            if (this.filterOrg('report')) {
                res = res.filter((rep) => {
                    return rep.value.org == this.$store.state.user.org_id
                })
            } else if (this.filterUser('report')) {
                res = res.filter((rep) => {
                    return rep.value.owner_id == this.$store.state.user._id
                })
            }
            this.reports = []
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.tot_reports = res.length
                this.reports = (orderByFields(res, {value: ['value.report_date', 'value.review_date'], order: ['desc', 'desc']})).slice(0,10)
                // console.log('res REPORT', this.reports)
                // this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            }
            console.log('%%%%%%% FINISH REPORT SEARCH', Date.now())
        },
        async searchOperations(from, to){
            console.log('%%%%%%% START OPERATION SEARCH', Date.now())
            if (!from) {
                from = 0
            }
            if (!to) {
                to = endOfDay(new Date()).getTime()
            }
            from = startOfDay(from).getTime()
            to = endOfDay(to).getTime()
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: this.filter })
            let ranges=[['op_date', from], ['op_date', to]]
            
            this.operations = []
            let res = await searchDesign(this.$store.state.$pouch, 'operations', 'operations/searchByData', 'range', ranges, false)
            if (this.filterOrg('operation')) {
                res = res.filter((op) => {
                    return op.value.org == this.$store.state.user.org_id
                })
            } else if (this.filterUser('operation')) {
                res = res.filter((op) => {
                    return op.value.assigned.includes(this.$store.state.user._id)
                })
            }
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.tot_operations = res.length
                this.operations = (orderByFields(res, {value: ['value.op_date', 'value.order_date'], order: ['desc', 'desc']})).slice(0,10)
                // console.log('res OPERATIONS', this.operations)
                // this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            }
            console.log('%%%%%%% FINISH OPERATION SEARCH', Date.now())
        },
        filterOrg(obj) {
            return filterByOrg(obj, 'view_org', this.$store.state.user.roles)
        },
        filterUser(obj) {
            return filterByUser(obj, 'view_owner', this.$store.state.user.roles)
        },
        goToInstrument(i_id) {
            this.closeQRSearchDialog()
            if (i_id) {
                this.$router.push({path: "/instruments/details", query: {i_id: i_id, back: "/instruments"}})
            } else {
                this.$refs.newInstrumentEdit.openDialog({});
            }
        },
        closeQRSearchDialog() {
            this.search_qr = false
        },
    }
}
</script>
